import { type Dispatch, type UnknownAction } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import type store from './redux-store/store';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

// @tgtg/core's async middleware makes dispatching its async actions (login, revalidateSession, …)
// return a promise, which redux's Dispatch type can't express.
export const dispatchAsync = (dispatch: Dispatch, action: UnknownAction): Promise<unknown> =>
  dispatch(action) as unknown as Promise<unknown>;
